const SAME_DOCUMENT_SEARCH_CHANGE_EVENT = "meta-video:search-change";

export function notifySameDocumentSearchChange(): void {
  window.dispatchEvent(new Event(SAME_DOCUMENT_SEARCH_CHANGE_EVENT));
}

export function subscribeToLocationSearchChanges(
  listener: () => void,
): () => void {
  window.addEventListener("popstate", listener);
  window.addEventListener(SAME_DOCUMENT_SEARCH_CHANGE_EVENT, listener);
  return () => {
    window.removeEventListener("popstate", listener);
    window.removeEventListener(SAME_DOCUMENT_SEARCH_CHANGE_EVENT, listener);
  };
}
